import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import { HtmlOnImage, SliderCTA } from './StartPageCardSlider';
import Image from '@jetshop/ui/Image';
import MaxWidth from '../../Layout/MaxWidth';
import { LinkEvaluator } from '../../../utils/LinkEvaluator';
import { cx } from 'linaria';

export const DualBoxWrapper = styled(MaxWidth)`
  display: flex;
  flex-direction: row;
  gap: 10px;

  ${theme.below.lg} {
    flex-direction: column;
    padding: 0 10px;
  }
`;

export const StartPageDualBox = ({ children, aspectRatio }) => {
  const aspectCheckedChildren = children?.map((child) => {
    return { ...child, props: { ...child.props, aspectRatio } };
  });

  return <DualBoxWrapper>{aspectCheckedChildren}</DualBoxWrapper>;
};

const DualBoxItemWrapper = styled('div')`
  overflow: hidden;
  background-color: #f0f0f0;
  position: relative;
  flex: 1;
  border-radius: 10px;

  .content-wrapper {
    position: absolute;
    top: 2rem;
    bottom: 2rem;
    left: 0px;
    right: 0px;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #fff;
    padding: 24px;
    display: flex;
    flex-direction: column;

    &.TOP {
      justify-content: flex-start;
    }

    &.MIDDLE {
      justify-content: center;
    }

    &.BOTTOM {
      justify-content: flex-end;
    }

    .html-on-image {
      > * {
        line-height: normal;
        margin: 0;
      }
    }
    .dualbox-cta {
      margin-top: 24px;
    }
    .position-top {
      margin-bottom: 24px;
    }
  }
`;

export const DualBoxItem = ({
  image,
  html,
  textShadow,
  buttonText,
  buttonTextFontWeight,
  buttonTextColor,
  buttonBackgroundColor,
  verticalAlignment = { value: 'MIDDLE' },
  link,
  aspectRatio,
}) => {
  return (
    <DualBoxItemWrapper>
      <LinkEvaluator link={link}>
        <Image
          src={image?.value}
          alt={''}
          cover={true}
          aspect={aspectRatio?.value ? aspectRatio?.value : { value: '1:1' }}
        />
        <div className={cx('content-wrapper', verticalAlignment?.value)}>
          <HtmlOnImage
            html={html}
            shadow={textShadow?.value ? textShadow : { value: 'none' }}
          />

          {buttonText?.value && (
            <SliderCTA
              className="dualbox-cta"
              buttontextcolor={buttonTextColor?.value ?? '#fff'}
              buttonbackgroundcolor={buttonBackgroundColor?.value ?? '#000'}
              fontweight={buttonTextFontWeight?.value ?? '700'}
            >
              {buttonText?.value}
            </SliderCTA>
          )}
        </div>
      </LinkEvaluator>
    </DualBoxItemWrapper>
  );
};
